/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DocsPlusIcon16Light } from './DocsPlusIcon16Light';
import { DocsPlusIcon16Regular } from './DocsPlusIcon16Regular';
import { DocsPlusIcon16Solid } from './DocsPlusIcon16Solid';
import { DocsPlusIcon20Light } from './DocsPlusIcon20Light';
import { DocsPlusIcon20Regular } from './DocsPlusIcon20Regular';
import { DocsPlusIcon20Solid } from './DocsPlusIcon20Solid';
import { DocsPlusIcon24Regular } from './DocsPlusIcon24Regular';
import { DocsPlusIcon24Solid } from './DocsPlusIcon24Solid';
import { DocsPlusIcon32Regular } from './DocsPlusIcon32Regular';
import { DocsPlusIcon64Regular } from './DocsPlusIcon64Regular';
var sizes = {
    16: {
        light: DocsPlusIcon16Light,
        regular: DocsPlusIcon16Regular,
        solid: DocsPlusIcon16Solid,
    },
    20: {
        light: DocsPlusIcon20Light,
        regular: DocsPlusIcon20Regular,
        solid: DocsPlusIcon20Solid,
    },
    24: {
        regular: DocsPlusIcon24Regular,
        solid: DocsPlusIcon24Solid,
    },
    32: {
        regular: DocsPlusIcon32Regular,
    },
    64: {
        regular: DocsPlusIcon64Regular,
    },
};
export var DocsPlusIcon = forwardRef('DocsPlusIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
